import { createSelector } from "@reduxjs/toolkit";

export const userSelector = (state) => state.authSlice.user;
export const isLoggedInSelector = (state) => state.authSlice.isLoggedIn;
const selectProperties = (state) => state.propertiesSlice.properties;
const selectFavourites = (state) => state.propertiesSlice.favourites;

export const selectFavouriteProperties = createSelector(
  [selectProperties, selectFavourites],
  (properties, favourites) => {
    return properties.filter((property) => {
      return favourites.includes(property.id); // Check if filtering is working
    });
  }
);
